export interface DeskApp {
    id: number;
    name: string;
    surName: string;
    code: string;
    type: AppType;
    secondType: AppSecondType;
    status: AppStatus;
    logo: string;
    redirectUrl?: string;
    version: string;
    inMenu: AppInMenuType;
}

export enum AppStatus {
    /**
     * 已启用
     * @type {AppStatus.STARTED}
     */
    STARTED = 1,

    /**
     * 已停用
     * @type {AppStatus.STOPPED}
     */
    STOPPED,

    /**
     * 启用中
     * @type {AppStatus.RUNNING}
     */
    RUNNING,

    /**
     * 停止中
     * @type {AppStatus.STOPPING}
     */
    STOPPING,

    /**
     * 重启中
     * @type {AppStatus.RESTARTING}
     */
    RESTARTING,

    /**
     * 启用异常
     * @type {AppStatus.START_ERROR}
     */
    START_ERROR,

    /**
     * 停用异常
     * @type {AppStatus.STOP_ERROR}
     */
    STOP_ERROR,

    /**
     * 重启异常
     * @type {AppStatus.RESTART_ERROR}
     */
    RESTART_ERROR,

    /**
     * 升级中
     * @type {AppStatus.UPGRADING}
     */
    UPGRADING,

    /**
     * 回滚中
     * @type {AppStatus.ROLLBACKING}
     */
    ROLLBACKING,

    /**
     * 回滚失败
     * @type {AppStatus.ROLLBACK_ERROR}
     */
    ROLLBACK_ERROR
}

export enum AppInMenuType {
    /**
     * 在菜单显示
     * @type {AppInMenuType.DISPLAY}
     */
    DISPLAY = 1,

    /**
     * 在菜单中隐藏
     * @type {AppInMenuType.HIDDEN}
     */
    HIDDEN,

    /**
     * 在菜单中禁用
     * @type {AppInMenuType.DISABLED}
     */
    DISABLED
}

/**
 * 应用类型
 */
export enum AppType {
    /**
     * 默认应用类型
     * @type {AppType.DEFAULT_APP}
     */
    DEFAULT_APP = 0,

    /**
     * 三方应用类型
     * @type {AppType.THIRD_PARTY_APP}
     */
    THIRD_PARTY_APP = 3,

    /**
     * 外部应用类型
     * @type {AppType.EXTERNAL_LINK_APP}
     */
    EXTERNAL_LINK_APP = 5,

    /**
     * 轻应用
     * @type {AppType.LIGHT_APP}
     */
    LIGHT_APP = 6,

    /**
     * 隐藏应用类型
     * @type {AppType.HIDDEN_APP}
     */
    HIDDEN_APP = 10,

    /**
     * 本地测试应用类型
     * @type {AppType.LOCAL_TEST_APP}
     */
    LOCAL_TEST_APP = 99
}

/**
 * 二级应用类型
 */
export enum AppSecondType {
    /**
     * 底层应用
     * @type {AppSecondType.BASE}
     */
    BASE = 1,

    /**
     * 核心应用
     * @type {AppSecondType.KERNEL}
     */
    KERNEL,

    /**
     * 业务应用
     * @type {AppSecondType.BUSINESS}
     */
    BUSINESS,

    /**
     * 存储应用
     * @type {AppSecondType.STORE}
     */
    STORE,

    /**
     * 前端应用
     * @type {AppSecondType.FRONT}
     */
    FRONT
}
